export default class {
    _id;
    _name;
    _areas;

    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    get areas() {
        return this._areas;
    }

    set areas (value) {
        this._areas = value;
    }

    constructor(id, name) {
        this._id = id;
        this._name = name;
        this._areas = []
    }
}